import React from 'react';
import amazonLogo from '../amazon_logo.svg';
import { ERR_CODE } from '../utils/constants';

class ErrorPage extends React.Component<any, any> {
    state = {
        code: ""
    };

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const errorCode = params.get(ERR_CODE);
        this.setState({
            code: this.props.code ?? errorCode ?? ""
        });
    }

    getErrorMessage() {
        switch (this.state.code) {
            case "404":
                return "Page not found.";
            case "403":
                return "Unauthorized."
            default:
                return "";
        }
    }

    render() {
        return (
            <div>
                <img className="amazon-logo" src={amazonLogo} alt="Amazon Logo" />
                <h4>An error was encountered with the requested page.</h4>
                { this.state.code &&
                    <h5>
                        <p>Cause: {this.getErrorMessage()}</p>
                    </h5>
                }
            </div>
        )
    };
}

export default ErrorPage;
